/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { BREAKPOINTPX } from "styles/base/variables";

interface ContainerProps {
  children: React.ReactNode;
}

const stylePadding = css`
  @media (max-width: ${BREAKPOINTPX.tablet}) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (min-width: ${BREAKPOINTPX.tablet}) and (max-width: ${BREAKPOINTPX.desktop}) {
    padding-left: 60px;
    padding-right: 60px;
  }
  @media (min-width: ${BREAKPOINTPX.desktop}) {
    padding-left: 120px;
    padding-right: 120px;
  }
`;

function Container({ children, ...props }: ContainerProps) {
  return (
    <div className="container" {...props} css={stylePadding}>
      {children}
    </div>
  );
}

export default Container;
